module.exports = __webpack_public_path__ + "images/index/culture_description_img_3.c5b8881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/culture_description_img_3.png
// module id = 4Cb7
// module chunks = 21